<script setup lang="ts">
import {ChevronDownIcon, ChevronUpIcon} from 'lucide-vue-next'
import {ref, type Ref, useTemplateRef} from "vue";
import {type MenuResponse} from "../../responses/MenuResponse";
import SelectedIcon from "./SelectedIcon.vue";
import {onClickOutside} from "@vueuse/core";

interface Props {
    menu: MenuResponse
}
const props = defineProps<Props>();
const toggled: Ref<boolean> = ref(false);

const target = useTemplateRef<HTMLElement>('categorymenu');
onClickOutside(target, event => toggled.value = false)
</script>

<template>
    <div ref="categorymenu" class="relative w-full lg:max-w-48 hidden lg:block">
        <button @click="toggled = !toggled;" class="relative flex rounded-lg h-12 px-4 w-full justify-center items-center border border-gray-200">
            <span class="font-medium text-sm">Kies een categorie</span>
            <ChevronDownIcon v-if="!toggled" class="h-5 w-5 ml-3"></ChevronDownIcon>
            <ChevronUpIcon v-else class="h-5 w-5 ml-3"></ChevronUpIcon>
        </button>

        <ul v-show="toggled" class="bg-white w-[300px] absolute z-40 left-0 top-14 shadow text-sm rounded-md divide-y divide-gray-200">
            <li v-for="item in menu.items">
                <a :href="item.slug" class="flex text-gray-500 hover:text-black hover:font-medium cursor-pointer px-3 py-3">
                    <span class="mr-3" v-show="item.icon !== 'null'">
                        <selected-icon v-if="item.icon" :name="item.icon" class="h-5 w-5"></selected-icon>
                    </span>
                    <span>
                        {{ item.label }}
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>
